import { render } from "./bindDepart.vue?vue&type=template&id=4ba2b0c0&scoped=true"
import script from "./bindDepart.vue?vue&type=script&lang=js"
export * from "./bindDepart.vue?vue&type=script&lang=js"

import "./bindDepart.vue?vue&type=style&index=0&id=4ba2b0c0&lang=less&scoped=true"

import exportComponent from "D:\\New Git\\tl-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba2b0c0"]])

export default __exports__